import React, { Component } from 'react'
import UserEditForm from "./form/edit.component.jsx"
import { AppContext } from '@lightspeed-invoicing/core-client/frontend'
import SideBar from '../common/layout/sidebar.component.jsx'
import { GlobalHelper } from '../indexImports.js'
import { Redirect } from 'react-router'
import Guard, { Permissions } from '../role/Guard.jsx'
import UserEditTabs from './useredit.component'

class UserEdit extends Component {

    constructor(props, context) {
        super(props, context);

        let cancelRedirectPath = ''
        let saveRedirectPath = ''

        if (this.props.location && this.props.location.state && this.props.location.state.cancelRedirectPath) {
            cancelRedirectPath = this.props.location.state.cancelRedirectPath
        }
        if (this.props.location && this.props.location.state && this.props.location.state.saveRedirectPath) {
            saveRedirectPath = this.props.location.state.saveRedirectPath
        }

        this.state = {
            user: {},
            userName: '',
            userForm: '',
            cancelRedirectPath: cancelRedirectPath || '/users/listing',
            saveRedirectPath: saveRedirectPath || '/users/listing',
        }
    }

    componentDidMount() {
        SideBar.activateMenu('account')
        const userId = this.props.match.params.userId
        AppContext.getApiClient().get('/users/' + userId).then(user => {
            const userForm = <UserEditForm
                user={user}
                cancelRedirectPath={this.state.cancelRedirectPath}
                saveRedirectPath={this.state.saveRedirectPath} />
            this.setState({
                userName: GlobalHelper.GetFormattedName(user),
                form: userForm,
                user: user
            })
        });
    }

    render() {
        if (!Guard.isAuthorized(Permissions.AccessAllUsers) && AppContext.getUserLoggedIn().id !== this.props.match.params.userId) {
            return <Redirect to={`/users/edit/${AppContext.getUserLoggedIn().id}`} />
        }

        return (
            <div>
                <UserEditTabs userId={this.state.user.id} />
                {this.state.form}
            </div>
        );
    }
}

export default UserEdit


// WEBPACK FOOTER //
// ./src/user/edit.component.jsx